import Vue from 'vue'
import App from '@/App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
import '@/assets/css/global.scss'
import service, { Service } from '@/services'
import { setContractInstance } from '@/services/request'
import LazyLoad from 'vue-lazyload'
import database, { StorageType } from '@va/storage'
import configs from './config'

const db = database.getInstance(StorageType.Local, configs.DB_NAME)

Vue.config.productionTip = false
declare module 'vue/types/vue' {
  interface Vue {
    $api: Service,
    $bus: Vue,
    $db: typeof db
  }
}

Vue.use(LazyLoad, {
  loading: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/702a/2e64/973e/9123190b-e379-46e2-a207-81d3ffc2614b',
  error: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/254a/cf84/e36a/ae503d79-a63e-48fc-a452-354a52bf3416',
  attempt: 0
})

Vue.prototype.$api = service
Vue.prototype.$db = db

setContractInstance(service)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
